import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDisplayText, FDTitleText } from '@facet-wealth/design';

const ScenarioSelectionRedefinedSectionMetaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDDisplayText,
    _customProps: { color: 'textSecondary', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDTitleText,
    _customProps: { size: 'lg', align: 'center' },
  }, overrideReadOnly);

export default ScenarioSelectionRedefinedSectionMetaOverride;
